(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
if (!customElements.get('lf-home-announcement')) {
  customElements.define('lf-home-announcement', class extends HTMLElement {
    connectedCallback() {
      this.closest('.shopify-section').hidden = false;
      this.abort = new AbortController();
      this.querySelector('.lf-home-announcement__close')?.addEventListener('click', () => {
        this.closest('.shopify-section').hidden = true;
        document.documentElement.style.setProperty('--topbar-height', '0px');
        const header = document.querySelector('.header');
        header?.setHeight?.();
        // The existing sticky header caches these bounds; refresh after the notice moves it.
        if (header?.headerSection) {
          header.headerBounds = header.headerSection.getBoundingClientRect();
          header.firstScrollTop = window.scrollY;
          header.initialHeaderHeight = header.getBoundingClientRect().height;
        }
        const focusTarget = header?.querySelector('.header__logo-link');
        focusTarget?.focus({ preventScroll: true });
      }, { signal: this.abort.signal });
      document.documentElement.style.setProperty('--topbar-height', '36px');
    }
    disconnectedCallback() {
      this.abort?.abort();
      document.documentElement.style.removeProperty('--topbar-height');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laflore-hero-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lf-hero-slider')) {
  customElements.define('lf-hero-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.lf-hero-slider__track');
      this.slides = Array.from(this.querySelectorAll('.lf-hero-slider__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-slide-index]'));
      this.activeIndex = 0;
      this.paused = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobileVideo = window.matchMedia('(max-width:767px)');
      this.videoPaused = new Set();
      this.inView = true;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, options);
      this.addEventListener('click', event => {
        const dot = event.target.closest('[data-slide-index]');
        const arrow = event.target.closest('[data-direction]');
        const pause = event.target.closest('.lf-hero-slider__pause');
        const videoControl = event.target.closest('[data-video-control]');
        if (videoControl) {
          const slide = videoControl.closest('.lf-hero-slider__slide');
          const video = this.getSlideVideo(slide);
          if (!video) return;
          if (video.paused) { this.videoPaused.delete(slide); video.play().catch(() => this.updateVideoButton(slide, false)); }
          else { this.videoPaused.add(slide); video.pause(); }
          return;
        }
        if (dot || arrow) {
          this.setPaused(true);
          this.go(dot ? Number(dot.dataset.slideIndex) : this.activeIndex + Number(arrow.dataset.direction));
        } else if (pause) this.setPaused(!this.paused);
      }, options);
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.setPaused(true);
        this.go(this.activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.track.addEventListener('pointerdown', event => {
        this.setPaused(true);
        this.pointerStart = {x:event.clientX,y:event.clientY};
        this.dragged = false;
      }, options);
      this.track.addEventListener('pointermove', event => {
        if (this.pointerStart && Math.hypot(event.clientX-this.pointerStart.x,event.clientY-this.pointerStart.y)>10) this.dragged=true;
      }, options);
      this.track.addEventListener('click', event => {
        if (this.dragged && event.target.closest('a')) { event.preventDefault(); event.stopPropagation(); }
        this.pointerStart=null;
      }, {signal:this.abort.signal,capture:true});
      this.addEventListener('mouseenter', () => this.stop(), options);
      this.addEventListener('mouseleave', () => this.start(), options);
      this.addEventListener('focusin', () => this.stop(), options);
      this.addEventListener('focusout', () => requestAnimationFrame(() => this.start()), options);
      document.addEventListener('visibilitychange', () => { document.hidden ? this.stop() : this.start(); this.syncVideos(); }, options);
      this.mobileVideo.addEventListener('change', () => this.syncVideos(), options);
      this.reducedMotion.addEventListener('change', () => this.syncVideos(), options);
      this.querySelectorAll('video').forEach(video => {
        const slide = video.closest('.lf-hero-slider__slide');
        video.addEventListener('playing', () => this.updateVideoButton(slide, true), options);
        video.addEventListener('pause', () => this.updateVideoButton(slide, false), options);
      });
      this.visibility = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.syncVideos(); }, {threshold:0.1});
      this.visibility.observe(this);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index < 0 || !this.contains(event.target)) return;
        this.setPaused(true);
        this.go(index, false);
      }, options);
      this.resize = new ResizeObserver(() => this.go(this.activeIndex, false));
      this.resize.observe(this.track);
      this.update();
      this.start();
    }
    disconnectedCallback() {
      this.stop();
      this.abort?.abort();
      this.resize?.disconnect();
      this.visibility?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
      cancelAnimationFrame(this.frame);
    }
    go(index, animate = true) {
      if (!this.slides.length) return;
      index = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({left:index * this.track.clientWidth,behavior:animate && !this.reducedMotion.matches ? 'smooth' : 'instant'});
      if (!animate) this.update();
    }
    update() {
      const index = Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth,1));
      this.activeIndex = Math.max(0,Math.min(index,this.slides.length - 1));
      this.slides.forEach((slide,i) => {
        const hidden = i !== this.activeIndex;
        slide.inert = hidden;
        slide.setAttribute('aria-hidden',String(hidden));
      });
      this.dots.forEach((dot,i) => dot.setAttribute('aria-current',String(i === this.activeIndex)));
      this.syncVideos();
    }
    getSlideVideo(slide) {
      return (this.mobileVideo.matches && slide.querySelector('.lf-hero-slider__video--mobile')) || slide.querySelector('.lf-hero-slider__video--desktop');
    }
    updateVideoButton(slide, playing) {
      const button = slide.querySelector('[data-video-control]');
      if (!button) return;
      button.setAttribute('aria-pressed',String(playing));
      button.setAttribute('aria-label',playing ? button.dataset.pauseLabel : button.dataset.playLabel);
      button.querySelector('path').setAttribute('d',playing ? 'M9 5v14M15 5v14' : 'm9 5 10 7-10 7Z');
    }
    syncVideos() {
      this.slides.forEach((slide,i) => {
        const selected = this.getSlideVideo(slide);
        slide.querySelectorAll('video').forEach(video => {
          if (video !== selected || i !== this.activeIndex || document.hidden || !this.inView) video.pause();
          else if (slide.dataset.videoAutoplay === 'true' && !this.reducedMotion.matches && !this.videoPaused.has(slide) && video.paused) video.play().catch(() => this.updateVideoButton(slide, false));
        });
      });
    }
    setPaused(value) {
      this.paused = value;
      const button = this.querySelector('.lf-hero-slider__pause');
      if (button) {
        button.setAttribute('aria-pressed',String(value));
        button.setAttribute('aria-label',value ? button.dataset.playLabel : button.dataset.pauseLabel);
        button.querySelector('path').setAttribute('d',value ? 'm9 5 10 7-10 7Z' : 'M9 5v14M15 5v14');
      }
      value ? this.stop() : this.start();
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    start() {
      this.stop();
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.paused || this.reducedMotion.matches || document.hidden || this.matches(':hover') || this.contains(document.activeElement) || window.Shopify?.designMode) return;
      this.timer = setInterval(() => this.go(this.activeIndex + 1),Number(this.dataset.interval) || 6000);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
